import ScheduleActivity from './ScheduleActivity';

export default ScheduleActivity;
